export const BillboardSearchFields = [
  "search_nr",
  "city",
  "district",
  "address_details",
  "description",
];
